import React from "react";
import { useSelector } from "react-redux";
import BillDetails from "./Details";
import CartItem from "./Item";

const Cart = () => {
  const { cart } = useSelector((state) => state.shopping);
  return (
    <div className="container 2xl:px-8 px-2 mx-auto">
      <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
      <div className="cartListContainer">
        <div className="space-y-6">
          {/* Cart Item */}
          {cart.map((item) => (
            <CartItem item={item} key={item.id} />
          ))}
          {/* Cart Items Ends */}
        </div>
        {/* Bill Details */}
        <BillDetails />
      </div>
    </div>
  );
};

export default Cart;
